import { render, staticRenderFns } from "./editWidgetAttribute.vue?vue&type=template&id=5e6d8870&scoped=true&"
import script from "./editWidgetAttribute.vue?vue&type=script&lang=js&"
export * from "./editWidgetAttribute.vue?vue&type=script&lang=js&"
import style0 from "./editWidgetAttribute.vue?vue&type=style&index=0&id=5e6d8870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6d8870",
  null
  
)

export default component.exports